import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Home } from './pages/Home';
import { RideOptions } from './pages/RideOptions';
import { Confirmation } from './pages/Confirmation';
import { RideTracking } from './pages/RideTracking';
import { Wallet } from './pages/Wallet';
import { Bookings } from './pages/Bookings';
import { Profile } from './pages/Profile';
import { Schedule } from './pages/Schedule';
import { ScheduleSuccess } from './pages/ScheduleSuccess';
import { Directory } from './pages/Directory';
import { DriverHome } from './pages/DriverHome';
import { DriverRides } from './pages/DriverRides';
import { DriverEarnings } from './pages/DriverEarnings';
import { AppProvider } from './context/AppContext';
export function App() {
  return <AppProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/login" element={<Login data-id="element-4" />} data-id="element-3" />
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/ride-options" element={<RideOptions data-id="element-8" />} data-id="element-7" />
          <Route path="/confirmation" element={<Confirmation data-id="element-10" />} data-id="element-9" />
          <Route path="/tracking" element={<RideTracking data-id="element-12" />} data-id="element-11" />
          <Route path="/wallet" element={<Wallet data-id="element-14" />} data-id="element-13" />
          <Route path="/bookings" element={<Bookings data-id="element-16" />} data-id="element-15" />
          <Route path="/profile" element={<Profile data-id="element-18" />} data-id="element-17" />
          <Route path="/schedule" element={<Schedule data-id="element-20" />} data-id="element-19" />
          <Route path="/schedule-success" element={<ScheduleSuccess data-id="element-22" />} data-id="element-21" />
          <Route path="/directory" element={<Directory data-id="element-24" />} data-id="element-23" />
          <Route path="/driver" element={<DriverHome data-id="element-26" />} data-id="element-25" />
          <Route path="/driver/rides" element={<DriverRides data-id="element-28" />} data-id="element-27" />
          <Route path="/driver/earnings" element={<DriverEarnings data-id="element-30" />} data-id="element-29" />
          <Route path="/driver/profile" element={<Profile data-id="element-32" />} data-id="element-31" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-34" />} data-id="element-33" />
        </Routes>
      </BrowserRouter>
    </AppProvider>;
}